import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import instagram from "../../../assets/svgs/icons/instagram-white.svg";
import linkedin from "../../../assets/svgs/icons/linkedin-white.svg";
import youtube from "../../../assets/svgs/icons/youtube-white.svg";
import logoTelemont from "../../../assets/svgs/telemont-logo-white.svg";
import { DOCUMENT_PATHS, openDocument } from "../../../constants/documents";
import { redirectToMedia } from "../../../utils/redirectToMedia";
import DefaultText from "../../typography/default-text";
import styles from "./styles.module.css";

const Footer = () => {

  const navigate = useNavigate();
  return (
    <footer className={styles["footer-container"]}>
      <img src={logoTelemont} alt="Logo Telemont" className={styles.logo} onClick={() => { navigate("/") }} />

      <div className={styles["footer-text-content"]} style={{ alignItems: "flex-start" }}>
        <div className={styles["footer-text-frame"]}>
          <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white">
            Conheça a telemont
          </DefaultText>
          <DefaultText color="white" size="xs" style={{ maxWidth: "455px" }}>
            Na TELEMONT, sabemos que o nosso trabalho faz a diferença e impacta diretamente a sua vida.
            Por isso, estamos comprometidos em oferecer sempre o melhor em serviços de telecomunicações e energia para pessoas e organizações.
          </DefaultText>
        </div>
        <div className={styles["footer-text-frame"]}>
          <div className={styles["footer-text-frame"]}>
            <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white" style={{ maxWidth: "337px" }}>
              Atendimento à Imprensa, Mídia e Responsabilidade Social
            </DefaultText>
            <DefaultText color="white" size="xs">
              comunicacao@telemont.com.br
            </DefaultText>
          </div>
          <div className={styles["footer-text-frame"]}>
            <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white">Contato Comercial</DefaultText>
            <DefaultText color="white" size="xs">
            comercial@telemont.com.br
            </DefaultText>
          </div>
        </div>
        <div className={styles["footer-text-frame"]}>
          <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white" maxWidth={'337px'}>
            Reclamações, denúncias, sugestões, críticas e elogios
          </DefaultText>
          <DefaultText color="white" size="xs" maxWidth={'229px'}>
            Ouvidoria Telemont <br />
            0800 033 7566 <br />
            ouvidoria@telemont.com.br
          </DefaultText>
        </div>
      </div>
      <div className={styles["footer-text-frame"]}>
        <div className={styles["media-items"]}>
          <img src={linkedin} alt="Ícone LinkedIm" className={styles["media-icon"]} onClick={() => { redirectToMedia("linkedin") }} />
          <img src={youtube} alt="Ícone Youtube" className={styles["media-icon"]} onClick={() => { redirectToMedia("youtube") }} />
          <img src={instagram} alt="Ícone Instagram" className={styles["media-icon"]} onClick={() => { redirectToMedia("instagram") }} />
        </div>
      </div>
      <Divider sx={{ backgroundColor: "var(--primary-white)" }} />
      <div className={styles["footer-text-content"]} style={{ alignItems: "flex-start" }}>
        <div className={styles["footer-text-frame"]}>
          <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white">
            A empresa
          </DefaultText>
          <DefaultText color="white" size="xs" style={{ maxWidth: "455px" }} className={styles["footer-action-button"]}
            onClick={() => { navigate("/empresa/sobre-nos"); }}
          >
            Sobre Nós
          </DefaultText>
          <DefaultText color="white" size="xs" style={{ maxWidth: "455px" }} className={styles["footer-action-button"]}
            onClick={() => { navigate("/empresa/pessoas"); }}
          >
            Pessoas
          </DefaultText>
          <DefaultText color="white" size="xs" style={{ maxWidth: "455px" }} className={styles["footer-action-button"]}
            onClick={() => { window.open("https://telemont.gupy.io/", "_blank"); }}
          >
            Trabalhe Conosco
          </DefaultText>
        </div>
        <div className={styles["footer-text-frame"]}>
          <div className={styles["footer-text-frame"]}>
            <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white">
              Serviços
            </DefaultText>
            <DefaultText color="white" size="xs" style={{ maxWidth: "455px" }} className={styles["footer-action-button"]}
              onClick={() => { navigate("/servicos/telecom"); }}
            >
              Telecom
            </DefaultText>
            <DefaultText color="white" size="xs" style={{ maxWidth: "455px" }} className={styles["footer-action-button"]}
              onClick={() => { navigate("/servicos/energia"); }}
            >
              Energia
            </DefaultText>
          </div>
        </div>
        <div className={styles["footer-text-frame"]}>
          <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white" maxWidth={'337px'}>
            Atendimento
          </DefaultText>
          <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { navigate("/contato") }}
          >
            Contato
          </DefaultText>
          {/* <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { navigate("/empresa/midia"); }}
          >
            Mídia
          </DefaultText> */}
          <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { navigate("/empresa/docs-politicas"); }}
          >
            Nossas Políticas
          </DefaultText>
        </div>
        <div className={styles["footer-text-frame"]}>
          <DefaultText sx={{ fontFamily: "Montserrat-Bold" }} size="small" color="white" maxWidth={'337px'}>
            Políticas
          </DefaultText>
          <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { navigate("/empresa/docs-politicas"); }}
          >
            Política de SGI
          </DefaultText>
          <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { openDocument(DOCUMENT_PATHS.politicaDePrivacidade); }}
          >
            Política de privacidade
          </DefaultText>
        </div>
        <div className={styles["footer-text-frame"]}>
          <DefaultText color="white" size="xs" maxWidth={'400px'} className={styles["footer-action-button"]}
            onClick={() => { navigate("/formulario-lgpd"); }}
          >
            Formulário para Requisição do Titular de Dados Pessoais - LGPD
          </DefaultText>
          <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { openDocument(DOCUMENT_PATHS.relatorioIgualdadeSalarial); }}
          >
            Relatório de Transparência e Igualdade Salarial
          </DefaultText>
          <DefaultText color="white" size="xs" maxWidth={'229px'} className={styles["footer-action-button"]}
            onClick={() => { openDocument(DOCUMENT_PATHS.relatorioSustentabilidade); }}
          >
            Relatório de Sustentabilidade
          </DefaultText>
        </div>
      </div>
      <DefaultText color="white" size="xs" alignSelf={'center'}>
        ©2024 Todos os direitos reservados a Telemont.
      </DefaultText>
    </footer>
  );
};

export default Footer;
